export default __webpack_public_path__ + "static/media/email.d1295a05.svg";